export class TranslatedError extends Error {
  constructor(message: string = "") {
    super(message);
  }
}
